import { Select } from '@material-ui/core';
import React, { useState } from 'react';
const SelectGrade = () => {
  const [selectedOption, setSelectedOption] = useState('');

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
  };
  return (
    <div>
      <Select
        style={{ width: '100px' }}
        id="selectExample"
        value={selectedOption}
        onChange={handleSelectChange}
      >
        <option value="option1">O</option>
        <option value="option2"> A+</option>
        <option value="option3"> A</option>
        <option value="option4"> B+</option>
        <option value="option5">B</option>
        <option value="option6">C</option>
        <option value="option7">P</option>
        <option value="option8">F</option>
        <option value="option9">R</option>
        <option value="option10">AB</option>
        <option value="option11">I</option>
        <option value="option12">S</option>
        <option value="option13">U</option>
      </Select>
    </div>
  );
};

export default SelectGrade;
